/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { AiTutorEvaluationResponseDimensionLevel } from './aiTutorEvaluationResponseDimensionLevel';

export interface AiTutorEvaluationResponseDimension {
  level?: AiTutorEvaluationResponseDimensionLevel;
}
